<div class="page-body">
    <h2>Виртуальная лаборатория «Физика»</h2>
    <h1>Тетрадь для лабораторных работ «Виртуальная лаборатория «Физика», раздел «АРХИМЕД</h1>
    <p>
        Тетрадь – сборник лабораторных работ, выполняемых в «Виртуальная лаборатория «Физика»,
        раздел «АРХИМЕД». Каждая лабораторная работа содержит одно или несколько заданий,
        объединенных одной темой для изучения.
    </p>
    <p>
        Каждый вариант лабораторной работы содержит случайным образом сгенерированные различные
        показатели заданий со встроенной автоматической проверкой.
    </p>
    <h3>Тетрадь для лабораторных работ «Физика», раздел «АРХИМЕД», это:</h3>
    <ul>
        <li>
            Просмотр перечня лабораторных работ, которые могут быть выполнены в Виртуальной
            лаборатории, из самой Виртуальной лаборатории и на веб-странице Тетрадей.
        </li>
        <li>
            Доступ к методическим указаниям по выполнению лабораторных работ из Виртуальной
            лаборатории и из веб-представления.
        </li>
        <li>Сохранение результатов выполнения заданий лабораторной работы.</li>
        <li>Автоматизированная проверка результатов выполнения лабораторной работы.</li>
        <li>
            Индикация правильности полученных результатов выполнения лабораторной работы по итогам
            проверки.
        </li>
    </ul>

    <h3>Тетрадь для лабораторных работ «Физика», раздел «АРХИМЕД»</h3>
    <img src="assets/vr/archimed/screenshots/1.png" />
    <img src="assets/vr/archimed/screenshots/2.png" />
    <img src="assets/vr/archimed/screenshots/3.png" />
    <img src="assets/vr/archimed/screenshots/4.png" />
    <h3>Пользовательская документация</h3>
    <a href="assets/vr/archimed/Инструкция по установке.pdf" download>Инструкция по установке</a>
    <a href="assets/vr/archimed/Руководство пользователя.pdf" download>Руководство пользователя</a>
    <a href="assets/vr/archimed/Лицензионное_соглашение_«Тетрадь_АРХИМЕД».pdf" download
        >Лицензионное соглашение</a
    >
</div>
